import googlePng from '@/assets/img/google.png'
import qqPng from '@/assets/img/qq.png'
import weChatPng from '@/assets/img/wechat.png'

export const IndustryTypeList = [
  { name: 'common_industry_building_cartoon', id: 1 },
  { name: 'common_industry_movie_effect', id: 2 },
  { name: 'common_industry_CG_header', id: 3 },
  { name: 'common_industry_theme_part', id: 4 },
  { name: 'common_industry_role_cartoon', id: 5 },
  { name: 'common_industry_exhibition', id: 6 },
  { name: 'common_industry_industrial_design', id: 7 },
  { name: 'common_industry_tv_cartoon', id: 8 },
  { name: 'common_industry_businsses_ad', id: 9 },
  { name: 'common_industry_car', id: 10 },
  { name: 'common_industry_picture', id: 11 },
  { name: 'common_industry_e_commerce', id: 10 },
]
export const Area = Object.freeze({
  BJ: 1,
  SH: 2,
  CD: 3,
  SZ: 4,
  HW: 5,
  GH: 6,
  PICTURE: 7,
  ZOMBIE: 8,
  DYY: 9,
  YZ: 21,
  OZ: 11,
  FZ: 13,
  BMZ: 15,
  NMZ: 17,
  DYZ: 19,
  HW1: 23,
  HW2: 25,
  AUTO: 100,
})

export const OverseasNameMap = new Map([
  ['亚洲', 'YZ'],
  ['欧洲', 'OZ'],
  ['非洲', 'FZ'],
  ['北美洲', 'BMZ'],
  ['南美洲', 'NMZ'],
  ['大洋洲', 'DYZ'],
])

export const OverseasMap = new Map([
  [Area.YZ, 'YZ'],
  [Area.OZ, 'OZ'],
  [Area.FZ, 'FZ'],
  [Area.BMZ, 'BMZ'],
  [Area.NMZ, 'NMZ'],
  [Area.DYZ, 'DYZ'],
  [Area.HW1, 'HW1'],
  [Area.HW2, 'HW2'],
  [Area.AUTO, 'AUTO'],
])

// 认证状态
export const AuthStatus = {
  NoCertified: 0,
  UnderReview: 2,
  Failed: 3,
  PendingReview: 4,
  Changing: 5,
  PersonalAuthSuccess: 6,
  EnterpriseAuthSuccess: 7,
}

// 用户类型 1个人用户 2企业用户
export const UserType = {
  Personal: 1,
  Business: 2,
}

// 国内外区域 1国内 2国外
export const Zone = {
  Domestic: 1,
  Foreign: 2,
}

export const Gigabyte = 1024 * 1024 * 1024

// 1--置灰 2 --显示
export const AshStatus = {
  Yes: 1,
  No: 2,
}

// 业务类型
export const businessTypeList = [
  {value: '', label: 'all'},
  {value: 1, label: 'animation'},
  {value: 0, label: 'renderings'},
  {value: 3, label: 'realityModeling'},
]

export const billDetailBusinessTypeList = [
  {value: '', label: 'all'},
  {value: 0, label: 'render'},
  {value: 3, label: 'realityModeling'},
]

// 收入类型
export const incomeTypeList = [
  { label: 'user_income_type_commonUser', value: 0 },
  { label: 'user_income_type_innerTest', value: 1 },
  { label: 'user_income_type_offlineCalculation', value: 2 },
]

export const viewUserType = {
  phone: 1,
  email: 2,
  level: 3,
  cpu: 4,
  gpu: 5,
}

// 支持附加功能软件
export const additionalFeatureCgList = Object.freeze({
  Maya: 2000,
  Max: 2001,
  ArnoldStandalone: 2003,
  Houdini: 2004,
  Cinema4D: 2005,
  Blender: 2007,
  VRStandalone: 2008,
  Clarisse: 2013,
  Nuke: 2015,
  Katana: 2016,
  Terragen: 2018,
  UnrealEngine: 2020,
  Vred: 2022,
  CustomSoftware: 2030,
})

// 操作分类
export const operationClassification = [
  {value: '', label: 'all'},
  {value: 1, label: 'basic_information'},
  {value: 2, label: 'account_settings'},
  {value: 3, label: 'price_setting'},
  {value: 4, label: 'general_render_settings'},
  {value: 5, label: 'risk_switch'},
  {value: 6, label: 'quota_setting'},
  {value: 7, label: 'system'},
  {value: 8, label: 'front_subaccount'},
  {value: 9, label: 'verified'},
]

// 邀请注册类型
export const inviteRegisterTypeList = [
  { label: 'user_invite_type_1', value: 1 },
  { label: 'user_invite_type_2', value: 2 },
  { label: 'user_invite_type_3', value: 3 },
]

// 用户类型 1个人用户 2企业用户
export const AIFlagType = {
  SpeedUp: 1,
  AIlossless: 2,
}

export const userRegisterIcon = new Map([
  [1, qqPng],
  [2, weChatPng],
  [6, googlePng],
])

export const AccountType = Object.freeze({
  main: 1,
  child: 2,
  dingChild: 3,
})
